var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appStatus && _vm.login === -1)?_c('div'):(_vm.appStatus && _vm.login === 0)?_c('div',[(_vm.$route.path === '/protocol')?_c('MyProtocol'):_c('MyLoin')],1):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }